/*
 * @Description:
 * @LastEditTime: 2024-03-15 16:36:31
 * @LastEditors: wudi
 * @Author: 何俊峰
 * @Date: 2022-12-29 10:22:11
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const routes = [
  {
    path: "",
    component: () => import("@/components/pdf.vue"),
  },
  {
    path: "/batch",
    component: () => import("@/components/pdfBatch.vue"),
    meta: {
      title: "批量签署",
    },
  },
];

const router = new Router({
  mode: "history",
  routes,
});

export default router;
